module.exports = __webpack_public_path__ + "static/media/hero-alt.7ef24872.jpg";